import { ProviderContext } from 'notistack';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Toast } from 'src/components/Toast';
import { useElectronUpdateStatus } from 'src/features/electron/ElectronUpdateContext';
import { getElectronAPI } from 'src/hooks/useElectron';

export const useElectronUpdates = (
  enqueueSnackbar: ProviderContext['enqueueSnackbar'],
  enableNewSidebar: boolean,
) => {
  const { t } = useTranslation();
  const { status } = useElectronUpdateStatus();
  const prevStatusRef = React.useRef(status);

  // Reset the ref when the sidebar flag turns off so the snackbar can fire
  React.useEffect(() => {
    if (!enableNewSidebar) {
      prevStatusRef.current = undefined as unknown as typeof status;
    }
  }, [enableNewSidebar]);

  React.useEffect(() => {
    const prev = prevStatusRef.current;
    prevStatusRef.current = status;

    if (status === 'ready' && prev !== 'ready' && !enableNewSidebar) {
      const api = getElectronAPI();
      enqueueSnackbar('Update ready', {
        persist: true,
        content: (key: string | number) => (
          <div key={key}>
            <Toast
              variant="info"
              title={t(($) => $.desktop_app.update_toast.title)}
              description={t(($) => $.desktop_app.update_toast.description)}
              actionProps={{
                onClick: () => api?.installUpdate(),
                children: t(($) => $.desktop_app.update_toast.restart_now),
                className: 'text-base',
              }}
            />
          </div>
        ),
      });
    }
  }, [status, enqueueSnackbar, enableNewSidebar, t]);
};
